import React, { Component } from 'react'
import UserProfile from '../../UserProfile'
import axios from 'axios'
import '../../standardcode/Standardcodes.css'
import history from '../../../history';
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css'
import Modal from 'react-bootstrap/Modal'
import Button from 'react-bootstrap/Button'
import authHeader from '../../authentication/authHeader'
import ReactTooltip from 'react-tooltip';
import multisort from 'multisort';
import { Store } from 'react-notifications-component'
import { findPageIndex } from '../../utils/Util'
import ocsHighlighRow from '../../utils/OcsHighlighRow'

class Staff extends Component {
    constructor(props) {
        super(props)
        this.state = {
            staffList: [],
            codesetItemId: '0',
            skillsList: [],
            showList: false,
            showModal: false,
            staffid: '',
            staffname: '',
            staffavailabilityList: [],
            sortConfig: {
                'firstName': { dataField: 'firstName', order: 'asc' },
            },
        }
        this.handleChange = this.handleChange.bind(this)
        this.gotoPageHandler = this.gotoPageHandler.bind(this);
        this.AddOpen = this.AddOpen.bind(this)
        this.getStaffList = this.getStaffList.bind(this)
        this.handleTableChange = this.handleTableChange.bind(this)
        this.headerSortingClasses = this.headerSortingClasses.bind(this)
    }
    componentDidMount() {
        this.getStaffList()
    }
    headerSortingClasses(order, column) {
        let i = 1
        if (this.state.sortConfig[column.dataField]) {
            for (const config in this.state.sortConfig) {
                if (config !== column.dataField) {
                    i++
                } else {
                    break
                }
            }
        }
        if (!this.state.sortConfig[column.dataField]) {
            return <span className="order-4" />;
        } else if (this.state.sortConfig[column.dataField].order === "asc") {
            return <span><span className="caret-4-asc" />{i > -1 ? '[' + i + ']' : ''}</span>;
        } else if (this.state.sortConfig[column.dataField].order === "desc") {
            return <span><span className="caret-4-desc" />{i > -1 ? '[' + i + ']' : ''}</span>;
        } else {
            return null;
        }
    };
    handleTableChange(
        type, { page, sizePerPage, sortField, sortOrder, data }) {
        let sortCol = {};
        if (type === "sort") {
            if (this.state.sortConfig[sortField]) {
                sortCol = {
                    ...this.state.sortConfig,
                    [sortField]: {
                        ...this.state.sortConfig[sortField],
                        order: "desc"
                    }
                };
                if (this.state.sortConfig[sortField].order === "asc")
                    this.setState({ sortConfig: sortCol });
                else
                    delete this.state.sortConfig[sortField]
            } else {
                const sortObj = {
                    dataField: sortField,
                    order: 'asc'
                };
                sortCol = { ...this.state.sortConfig, [sortField]: sortObj };
                this.setState({ sortConfig: sortCol });
            }

            let criteria = [];
            for (const config in sortCol) {
                if (sortCol[config].order === "asc") {
                    criteria.push(config)
                } else {
                    criteria.push('~' + config)
                }
            }
            multisort(data, criteria)
        }
    };
    gotoPageHandler() {
        const p = findPageIndex(this.state.staffList, 'staffId', UserProfile.getHightlightIds())
        this.setState({ staffList: this.state.staffList });
        this.node.paginationContext.currPage = p;
    }
    getStaffList() {
        axios.get('/activeclinicslist', { headers: authHeader() })
            .then(response1 => {
                axios.get('/skills', { headers: authHeader() })
                    .then(response2 => {
                        if (UserProfile.getClinicId() > 0) {
                            axios.get('/staffclinics/' + UserProfile.getClinicId(), { headers: authHeader() })
                                .then(response3 => {
                                    axios.get('/staffavailabilityforClinic/' + UserProfile.getClinicId(), { headers: authHeader() })
                                        .then(response4 => {
                                            let dataset = [...response3.data]
                                            dataset.sort((a, b) => { return a.firstName < b.firstName ? -1 : a.firstName > b.firstName ? 1 : 0 })
                                            this.setState({
                                                staffavailabilityList: response4.data,
                                                staffList: dataset,
                                                codesetItemId: UserProfile.getClinicId(),
                                                showList: true,
                                                skillsList: response2.data
                                            });
                                            this.gotoPage.click();
                                        })
                                        .catch(function (error) {
                                            console.log(error);
                                            history.push('/Errorpage')
                                        })
                                })
                                .catch(function (error) {
                                    console.log('response3 : ', error);
                                    history.push('/Errorpage')
                                })
                        } else {
                            this.setState({
                                skillsList: response2.data
                            });
                        }
                    })
                    .catch(function (error) {
                        console.log('response2  :', error);
                        history.push('/Errorpage')
                    })
            })
            .catch(function (error) {
                console.log('response1 : ', error);
                history.push('/Errorpage')
            })
    }
    handleChange(event) {
        const { name, value } = event.target
        axios.get('/staffclinics/' + event.target.value, { headers: authHeader() })
            .then(response => {
                axios.get('/staffavailabilityforClinic/' + value, { headers: authHeader() })
                    .then(response4 => {
                        this.setState({
                            staffavailabilityList: response4.data,
                            staffList: response.data,
                            [name]: value,
                            showList: true
                        });
                    })
                    .catch(function (error) {
                        console.log(error);
                        history.push('/Errorpage')
                    })
            })
            .catch(function (error) {
                console.log(error);
                history.push('/Errorpage')
            })
    }
    AddOpen() {
        history.push('/Staffadd')
    }
    EditOpen(id) {
        history.push('/Staffedit:' + id)
    }
    DeleteOpen(id) {
        UserProfile.setSelectedId(this.state.codesetItemId)
        axios.put('/staffdel/' + this.state.staffid, '', { headers: authHeader() })
            .then(response => {
                this.getStaffList()
                this.handleClose()
                Store.addNotification({
                    title: "Deleted",
                    message: `'${this.state.staffname}' Staff of '${UserProfile.getClinicName()}' is deleted`,
                    type: "info",
                    insert: "top",
                    container: "top-right",
                    dismiss: {
                        duration: window['runConfig'].deleteNotification.displayInterval,
                        onScreen: true
                    }
                });
            })
            .catch(function (error) {
                console.log(error);
                history.push('/Errorpage')
            })
    }
    handleClose() {
        this.setState({
            showModal: false
        })
    }
    handleShow(id, name) {
        this.setState({
            staffid: id,
            staffname: name,
            showModal: true
        })
    }
    render() {
        const columns = [
            {
                dataField: 'staffId',
                text: '#',
                formatter: (cell, row, index) => (
                    index + 1
                ),
                headerStyle: { width: '5%' }
            },
            {
                dataField: 'firstName',
                text: 'Name',
                sort: true,
                headerStyle: { width: '25%' },
                formatter: (cell, row) => (
                    row.firstName + ' ' + row.lastName
                )
            },
            {
                dataField: 'description',
                text: 'Description',
                sort: true,
                headerStyle: { width: '25%' }
            },
            {
                dataField: 'skillId',
                text: 'Skills',
                sort: true,
                headerStyle: { width: '10%' },
                formatter: (cell, row) => (
                    this.state.skillsList.filter(restype => restype.codesetItemId === row.skillId).map((x, i) => { return x.name })
                )
            },
            {
                dataField: 'displayOrder',
                text: 'Display Order',
                sort: true,
                headerStyle: { width: '10%', textAlign: 'right' },
                align: 'right'
            },
            {
                dataField: 'activeStatus',
                text: 'Active',
                sort: true,
                headerStyle: { width: '10%', textAlign: 'center' },
                formatter: (cell, row) => (
                    row.activeStatus == 'Y' ? 'Yes' : 'No'
                ),
                align: 'center'
            },
            {
                dataField: 'action',
                text: 'Action',
                headerStyle: { width: '14%', textAlign: 'center' },
                formatter: (cellContent, row) => (
                    <div>
                        <ReactTooltip />
                        <button type="button" className="btn btn-primary" onClick={this.EditOpen.bind(this, row.staffId)} data-tip="Edit">Edit</button>&nbsp;
                        {this.state.staffavailabilityList.find(x => x.staffId === row.staffId) ?
                            <button type="button" className="btn btn-secondary" disabled onClick={this.handleShow.bind(this, row.staffId, row.firstName + ' ' + row.lastName)} data-tip="Delete">Delete</button>
                            :
                            <button type="button" className="btn btn-primary" onClick={this.handleShow.bind(this, row.staffId, row.firstName + ' ' + row.lastName)} data-tip="Delete">Delete</button>
                        }
                    </div>
                ),
                align: 'center'
            }
        ];
        return (
            <div>
                <div className="form-row align-items-center my-1">
                    <div className="col">
                        <div className="float-right">
                            <div style={{ display: (this.state.showList ? 'block' : 'none') }}>
                                <div className="d-flex justify-content-end">
                                    <ReactTooltip />
                                    <button type="button" className="btn btn-primary mb-2" align="right" data-tip="Add New" data-toggle="tooltip" data-placement="top" onClick={this.AddOpen} >Add Staff</button>
                                    <button type="button" onClick={this.gotoPageHandler} ref={input => this.gotoPage = input} style={{ display: 'none' }}></button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div style={{ display: (this.state.showList ? 'block' : 'none') }}>
                    <div>
                        <Modal show={this.state.showModal} onHide={this.handleClose.bind(this)}>
                            <ReactTooltip />
                            <Modal.Header closeButton>
                                <Modal.Title>Delete Confirmation</Modal.Title>
                            </Modal.Header>
                            <Modal.Body>Are you sure you want to delete the staff <b>{this.state.staffname}</b>?</Modal.Body>
                            <Modal.Footer>
                                <Button variant="primary" data-tip="Yes" onClick={this.DeleteOpen.bind(this)}>
                                    Yes
                                </Button>
                                <Button variant="secondary" data-tip="No" onClick={this.handleClose.bind(this)}>
                                    No
                                </Button>
                            </Modal.Footer>
                        </Modal>
                    </div>
                    <div>
                        {<BootstrapTable
                            remote={{
                                filter: false,
                                pagination: false,
                                sort: true,
                                cellEdit: false
                            }}
                            keyField='staffId'
                            data={this.state.staffList}
                            columns={columns}
                            ref={(n) => (this.node = n)}
                            pagination={paginationFactory()}
                            noDataIndication="No Record(s)"
                            striped hover condensed
                            rowClasses='table table-sm'
                            headerClasses="thread"
                            selectRow={ocsHighlighRow(UserProfile.getHightlightIds(), UserProfile.getHightlightType())}
                            onTableChange={this.handleTableChange}
                            sort={{ sortCaret: this.headerSortingClasses }}
                        />}
                    </div>
                </div>
            </div>
        )
    }
}

export default Staff
